import React, { useEffect, useState } from 'react';
import { Box, Flex, Drawer, Typography, TextInput, Button, IconButton, color, Card } from '@kistech/kis-ui';
import { Box as MuiBox, Typography as MuiTypography, Grid } from '@mui/material';
import { useActions } from 'hooks/useActions';
import { selectors as authSelectors } from 'store/auth';
import { useSelector } from 'react-redux';
import { actions as kioskActions, selectors as kioskSelectors, Kiosk } from 'store/kiosks';
import { useStyles } from '../styled';

export interface KioskRestockDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  kiosk: Kiosk;
}

export const KioskRestockDrawer = (props: KioskRestockDrawerProps) => {
  const { isOpen, onClose, kiosk } = props;
  const { updateKiosk, logEvent, resetAction } = useActions({
    updateKiosk: kioskActions.updateKiosk,
    logEvent: kioskActions.logEvent,
    resetAction: kioskActions.resetAction
  });
  const admin = useSelector(authSelectors.selectAdmin);
  const { success } = useSelector(kioskSelectors.selectAction);
  const [stockValue, setStockValue] = useState('');
  const classes = useStyles({ showDrawer: isOpen })();

  useEffect(() => {
    if (isOpen && success) {
      onClose();
      resetAction();
    }
    setStockValue('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, success]);

  const validateAndSetStockValue = (value: string) => {
    if (value && !isNaN(Number(value)) && Number(value) >= 0) {
      setStockValue(Math.abs(Number(value)).toString());
    } else if (!value) {
      setStockValue(value);
    } else {
      setStockValue(stockValue);
    }
  };

  // on click data entry overlay
  const onConfirmTicketStock = () => {
    let payload = null;
    payload = { currentStock: stockValue, id: kiosk.id };
    updateKiosk(payload);
    // kioskId needs to be replaced with exact data.
    logEvent({ kioskId: kiosk.id, adminId: admin ? admin.id : '' });
  };

  return (
    <>
      <Drawer isOpen={isOpen} onClose={onClose} hasBorderRadius>
        <Grid container className={classes.kioskRestockDetailsOverlay}>
          <Card fullHeight>
            <Grid className={classes.kioskOverlayHeaderBlock}>
              <Grid className={classes.kioskOverlayHeading}>
                <Flex>
                  <MuiTypography className={classes.kioskRestockHeading} style={{ fontWeight: 600 }}>
                    Load Ticket Stock
                  </MuiTypography>
                </Flex>
              </Grid>
              <Grid className={classes.kioskOverlayCloseIcon}>
                <IconButton
                  name="exit_circle"
                  appearance="transparent"
                  size={40}
                  onClick={onClose}
                  data-testid="kiosk-restock-x"
                />
              </Grid>
            </Grid>
            <Box padding="2 6" fullWidth bg="light-gray">
              <Typography weight={600} size={16}>
                {kiosk.name}
              </Typography>
            </Box>
            <Card.Divider color={color.BORDER} />
            <MuiBox className={classes.kioskRestockBox}>
              <Box margin="6 0 5" flexOverride="none">
                <MuiTypography className={classes.restockDescText}>How much ticket stock did you load?</MuiTypography>
              </Box>
              <MuiBox className={classes.ReloadDataButton}>
                <TextInput
                  type="text"
                  size="medium"
                  align="center"
                  fullWidth
                  placeholder={'Enter Ticket Stock'}
                  value={stockValue}
                  onChange={(e) => validateAndSetStockValue(e.target.value)}
                />
              </MuiBox>
              {/* button */}
              <MuiBox className={classes.saveButtonBox}>
                <Button
                  size="small"
                  appearance="primary"
                  onClick={onConfirmTicketStock}
                  className={classes.saveButton}
                  isDisabled={!!!stockValue}
                >
                  Save
                </Button>
              </MuiBox>
            </MuiBox>
          </Card>
        </Grid>
      </Drawer>
    </>
  );
};
